import {ButtonIconTooltip, HStack, Text, TrashIcon} from "@hosttools/frontend";
import type React from "react";
import {memo, useCallback} from "react";

export type Props = {
    iCalURL: string;
    deleteCalendar: (iCalURL: string) => void;
};

const ImportCalendarItem: React.FC<Props> = ({iCalURL, deleteCalendar}) => {
    const handleDeleteCalendar = useCallback(() => {
        deleteCalendar(iCalURL);
    }, [iCalURL, deleteCalendar]);

    return (
        <HStack className="justify-between items-center border border-solid border-blueGray-100 rounded-sm px-2 py-1">
            <Text isTruncated className="max-w-[80%]" variant="xs">
                {iCalURL}
            </Text>
            <ButtonIconTooltip
                icon={TrashIcon}
                testID="btn-delete-ical-url"
                tooltip="Remove"
                onPress={handleDeleteCalendar}
            />
        </HStack>
    );
};

export default memo(ImportCalendarItem);
